import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {RootState} from "@/store/types/RootState";

import {IInvestmentDTO} from "../types/IInvestmentListDTO";

interface IInvestmentLeadModalState {
    investment: IInvestmentDTO | null;
    isSent: boolean;
}

const INITIAL_STATE: IInvestmentLeadModalState = {
    investment: null,
    isSent: false
};

export const investmentLeadModalSlice = createSlice({
    initialState: INITIAL_STATE,
    name: "investmentLeadModal",
    reducers: {
        closeInvestmentLeadModal: () => INITIAL_STATE,
        markInvestmentLeadSent: (state) => {
            state.isSent = true;
        },
        openInvestmentLeadModal: (_state, action: PayloadAction<IInvestmentDTO>) => ({investment: action.payload, isSent: false})
    }
});

export const {closeInvestmentLeadModal, markInvestmentLeadSent, openInvestmentLeadModal} = investmentLeadModalSlice.actions;
export const selectInvestmentLeadModal = (state: RootState) => state.investmentLeadModal;
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {RootState} from "@/store/types/RootState";

import {IInvestmentDTO} from "../types/IInvestmentListDTO";

interface IInvestmentLeadModalState {
    investment: IInvestmentDTO | null;
    isSent: boolean;
}

const INITIAL_STATE: IInvestmentLeadModalState = {
    investment: null,
    isSent: false
};

export const investmentLeadModalSlice = createSlice({
    initialState: INITIAL_STATE,
    name: "investmentLeadModal",
    reducers: {
        closeInvestmentLeadModal: () => INITIAL_STATE,
        markInvestmentLeadSent: (state) => {
            state.isSent = true;
        },
        openInvestmentLeadModal: (_state, action: PayloadAction<IInvestmentDTO>) => ({investment: action.payload, isSent: false})
    }
});

export const {closeInvestmentLeadModal, markInvestmentLeadSent, openInvestmentLeadModal} = investmentLeadModalSlice.actions;
export const selectInvestmentLeadModal = (state: RootState) => state.investmentLeadModal;
